import * as React from "react"
import {DrawerSeeker} from "@ui-seeker/core";
import {adminProductReviewDetailsClicked} from "../@signals";
import {isEmpty} from "@ui-seeker/utils";

import {ModalCarouselImagesSeeker, ModalCarouselSeeker, ModalCarouselVideosSeeker} from "@components";
import AdminProductReviewDetailsDrawerContent from "./Content";
import { useAdminProductReviewDetails } from "../@hooks";
import { useSignal } from "@preact/signals-react";


export default function AdminProductReviewDetailsDrawer() {

	const { detailsData, showDetails } = useAdminProductReviewDetails()

	const isModalVideo = useSignal(false)
	const multimediaCarousel = useSignal([])
	const multimediaCarouselInitPos = useSignal(0)

	if (!showDetails) return <></>

	return <DrawerSeeker
		hideActions
		isOpen={!isEmpty(detailsData)}
		controller={() => adminProductReviewDetailsClicked.value = null}
		title="SKU Details"
		width="30%"
	>
		<AdminProductReviewDetailsDrawerContent 
			data={detailsData} 
			isModalVideo={isModalVideo}  
			multimediaCarousel={multimediaCarousel}
			multimediaCarouselInitPos={multimediaCarouselInitPos}
		/>

		<ModalCarouselSeeker
            isOpen={multimediaCarousel.value?.length > 0}
            controller={() => batch(() => {
				multimediaCarousel.value = []
				isModalVideo.value = false
			})}
            multimedia={multimediaCarousel.value}
            initPos={multimediaCarouselInitPos.value}
			isVideo={isModalVideo.value}
        />
	</DrawerSeeker>
}